import CaseCreationIcon from './svgIcons/Case Creation.svg'
import BackOfficeTrayIcon from './svgIcons/Back Office Tray.svg'
import MisReportIcon from './svgIcons/MIS Report.svg'
import ConfigurationIcon from './svgIcons/Configuration.svg'
import QcTrayIcon from './svgIcons/QC Tray.svg'
import SortingIcon from './svgIcons/Sorting.svg'
import DashboardWhiteIcon from './svgIcons/Dashboard whiteIcon.svg'
import caseCreationWhiteIcon from './svgIcons/CaseCreation whiteIcon.svg'
import BackOfficeWhiteIcon from './svgIcons/Back Office Tray whiteIcon.svg'
import MisReportWhiteIcon from './svgIcons/MIS Report white icon.svg'
import ConfigurationWhiteIcon from './svgIcons/Configuration white Icon.svg'
import QCTrayWhiteIcon from './svgIcons/QC Tray whiteIcon.svg'
import CommmissionPayoutWhiteIcon from './svgIcons/Commission Payouts White icon.svg'
import CommissionPayout from './svgIcons/CommissionPayoutIcon.svg'
import GreenTickIcon from './svgIcons/GreenTickIcon.svg'
import EyeIcon from './svgIcons/EyeIcon.svg'
import DownloadIcon from './svgIcons/DownloadIcon.svg'
import FailedIcon from './svgIcons/FailedIcon.svg'
import SuccessIcon from './svgIcons/SuccessIcon.svg'
import EyeBlackIcon from './svgIcons/EyeIconBlack.svg'
import CopyrightIcon from './svgIcons/CopyrightIcon.svg'
import RightArrowIcon from './svgIcons/chevronRightIcon.svg'
import AddIcon from './svgIcons/AddIcon.svg'
import DeleteIcon from './svgIcons/DeleteIcon.svg'
import BigGreenTickIcon from './svgIcons/BigGreenTickIcon.svg'
import ReportDownloadIcon from './svgIcons/DownloadReportIcon.svg'
import DeleteUploadIcon from './svgIcons/DeleteUploadIcon.svg'
import AddUploadIcon from './svgIcons/AddUploadIcon.svg'
import UploadSuccessIcon from './svgIcons/DownloadTickIcon.svg'
import PendingIcon from './svgIcons/PendingIcon.svg'
import EditIcon from './svgIcons/EditIcon.svg'
import CasereAssignmentIcon from './svgIcons/CaseReassignmentWhiteIcon.svg'
import CasereAssignmentBlueIcon from './svgIcons/CaseReassignmnetBlueIcon.svg'
import LeaveWhiteIcon from './svgIcons/LeaveWhiteIcon.svg'
import LeaveBlueIcon from './svgIcons/LeaveBlueIcon.svg'


// Layout Icons
import AssignmentsIcon from './layoutSvg/assignments.svg'
import CatalogueIcon from './layoutSvg/catalogue.svg'
import DashboardIcon from './layoutSvg/dashboard.svg'
import DropdownIcon from './layoutSvg/dropdown.svg'
import FinanceIcon from './layoutSvg/finance.svg'
import LogoutIcon from './layoutSvg/logout.svg'
import MainLogoIcon from './layoutSvg/mainLogo.svg'
import MasterIcon from './layoutSvg/master.svg'
import MenuIcon from './layoutSvg/menu.svg'
import RequestIcon from './layoutSvg/request.svg'
import SettingsIcon from './layoutSvg/settings.svg'


// Grid icon
import GridDownloadIcon from './svgIcons/grid-download.svg'
import GridFilterIcon from './svgIcons/grid-filter.svg'
import GridFullScreeIcon from './svgIcons/grid-fullscreen.svg'
import SearchIcon from './svgIcons/custom-search.svg'
import BackArrowIcon from './svgIcons/back-arrow.svg'
import CheckIcon from './svgIcons/checkIcon.svg'
import ListDeleteIcon from './svgIcons/list_delete.svg'
import UploadIcon from './svgIcons/upload.svg'
import ReportIcon from './svgIcons/ReportIcon.svg'
import VerifierIcon from './svgIcons/VerifierIcon.svg'



export const IMAGES_ICON = {
    CaseCreationIcon, BackOfficeTrayIcon, MisReportIcon, ConfigurationIcon, QcTrayIcon, SortingIcon, DashboardWhiteIcon,
    caseCreationWhiteIcon, BackOfficeWhiteIcon, MisReportWhiteIcon, ConfigurationWhiteIcon, QCTrayWhiteIcon, CommmissionPayoutWhiteIcon,
    CommissionPayout, GreenTickIcon, EyeIcon, DownloadIcon, FailedIcon, SuccessIcon, EyeBlackIcon, CopyrightIcon, RightArrowIcon, DeleteIcon,
    AddIcon, BigGreenTickIcon, ReportDownloadIcon, DeleteUploadIcon, AddUploadIcon, UploadSuccessIcon, PendingIcon, EditIcon,
    CasereAssignmentIcon, CasereAssignmentBlueIcon, LeaveBlueIcon, LeaveWhiteIcon, 

    AssignmentsIcon, CatalogueIcon, DashboardIcon, DropdownIcon, FinanceIcon, ReportIcon, VerifierIcon, LogoutIcon, MainLogoIcon, MasterIcon, MenuIcon, RequestIcon, SettingsIcon,
    GridDownloadIcon, GridFilterIcon, GridFullScreeIcon, SearchIcon, BackArrowIcon, CheckIcon, ListDeleteIcon, UploadIcon,
}